import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=0f8e50c3&scoped=true&"
import script from "./HeaderBlock.vue?vue&type=script&lang=js&"
export * from "./HeaderBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBlock.vue?vue&type=style&index=0&id=0f8e50c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8e50c3",
  null
  
)

export default component.exports